import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { useFollowing } from '@hooks/followers';

import { useAction, useFeatureFlag, useOnMount } from '@hooks';

export const FollowerInitializer: React.FC = () => {
	const isEnabled = useFeatureFlag(FeatureFlag.Followers);

	const load = useAction(useFollowing.loadAction);

	useOnMount(() => {
		if (isEnabled) {
			load();
		}
	});

	return null;
};
